import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { TypeKey } from '@wissenswerft/core/data';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { NamedItemComponent } from '@wissenswerft/organizational-structure';

@Component({
  selector: 'ubt-measure-type',
  templateUrl: './measure-type.component.html',
  styleUrls: ['./measure-type.component.scss']
})
export class MeasureTypeComponent implements AfterViewInit, OnDestroy{
  @ViewChild('namedItem') namedItem: NamedItemComponent;
  public typeKey: TypeKey = TypeKey.measureType;
  private subscriptions : Subscription[] = [];

  constructor(public dataService: DataService) { }

  ngAfterViewInit(): void {
    this.namedItem.showIdent=false;
    this.namedItem.showNotification.subscribe(message => {
      this.dataService.appService.callNotification(message);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }
}